/**
 * Queue.
 *
 * @param {Object} params - Queue API object
 * @param {number} params.threshold_step - How many user per wave
 * @param {number} params.threshold_duration - How many time between waves
 * @param {number} params.threshold_value - Highest ticket number allowed to enter
 * @param {number} params.active_count - Users currently in the queue
 * @param {number} params.distributor_id - Last ticket number emit
 * @param {Object} params.translations - Custom translations
 * @param {Object} params.image_details - Image
 * @param {date} params.open_date - Open Date
 */
import { ArgumentError } from '../utils/errors';
import { BaseAPIModel, fetcher } from '@weezevent/weezjs-core';

export default class QueueModel extends BaseAPIModel {
    fields() {
        return {};
    }

    /**
     * Save item to API
     */
    save(...args) {
        return this.constructor.save(this, ...args);
    }

    static save(objects, ...args) {
        if (!(objects instanceof Array)) {
            objects = [objects];
        }

        if (objects.some(object => !(object instanceof this))) {
            throw new Error(`[Model][${this.name}] Cannot save objects from other models`);
        }

        let singleObject = objects.length === 1;

        let data = singleObject ? objects[0].toAPI() : objects.map(object => object.toAPI());
        let url = singleObject ? this.getItemUrl(...args) : this.getListUrl(...args);

        return fetcher.patch(url, { data });
    }

    get imageDetail() {
        return this.object.image_detail;
    }

    get videoDetail() {
        return this.object.video_detail;
    }

    get openDate() {
        return this.object.open_date;
    }

    get waitingTime() {
        return this.object.waiting_time;
    }

    get thresholdStep() {
        return this.object.threshold_step;
    }

    get thresholdDuration() {
        return this.object.threshold_duration;
    }

    get thresholdValue() {
        return this.object.threshold_value;
    }

    get activeCount() {
        return this.object.active_count;
    }

    get distributorId() {
        return this.object.distributor_id;
    }

    get displayRank() {
        return this.object.display_rank;
    }

    get translations() {
        return this.object.translations;
    }

    get letInCount() {
        return this.object.let_in_count;
    }

    get letInLimit() {
        return this.object.let_in_limit;
    }

    get customCss() {
        return this.object.custom_css || '';
    }

    get isFull() {
        return this.object.let_in_limit !== null && this.object.let_in_count >= this.object.let_in_limit;
    }

    static listUrl({ organizationId, eventId, widgetKey = 'default' }) {
        if (!organizationId || !eventId) {
            throw new ArgumentError(`[Model][Queue][getAll] organizationId, eventId are mandatory`);
        }

        return `/ticket/organizations/${organizationId}/events/${eventId}/queues/${widgetKey}`;
    }

    /**
     * Gets the url for this object(s)
     */
    static getItemUrl(...args) {
        return `${this.getListUrl(args[0])}`;
    }

    static getListUrl({ organizationId, eventId, widgetKey = 'default' }) {
        if (!organizationId) {
            throw new ArgumentError('[Model][Subscription] organizationId is mandatory');
        }
        return `/ticket/organizations/${organizationId}/events/${eventId}/queues/${widgetKey}`;
    }
}
